import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {EDIT_MODE} from "../../../../../wpconfig"

import * as Actions from "../../../../../store/modules/scholars";
import * as FActions from "../../../../../store/modules/footer";
import * as func from "../../../../../utils/functions";
import IdsItem from "./item";

class Ids extends Component {
	constructor(props) {
		super(props);

		this.state = {
			category: [],
			categoryType: 'scholar_id_type',
			categoryName: [],
			insertRecord: null,
			editIndex : '',
			type : '',
			field : 'scholar_id_type',
			pkKey : 'ID'
		}

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);

		this.showMessage = this.showMessage.bind(this);

		func.getData("code/search/" + this.state.categoryType, {}).then((response) => {
			const t = {type : response.records[0].code_id};
			t.category = response.records;
			t.categoryName = {}
			response.records.map((r, i) => {
				t.categoryName[r.code_id] = r.code_name;
			});
			this.setState(t);
		});
	}

	onInsert() {
		const record = this.props.record;

		if (record[this.state.field].length > 0 && record[this.state.field][0][this.state.pkKey] === '') {
			this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
				'ID' : 0,
        'id_type' : "",
        'id_value' : "",
        'label' : "",
				'is_edit' : true
			}
			this.onEditIndex(0);
			record[this.state.field].unshift(insertRecord);
			this.props.dataActions.setScholar({"record": record});
		}
	}

	onUpdate(index, item, render) {
		const record = this.props.record;
		record[this.state.field][index] = item;
		this.props.dataActions.setScholar({"record": record});
		if(render)
			this.forceUpdate();
	}

	onRemove(index) {
		const record = this.props.record;
		record[this.state.field].splice(index, 1);
		this.props.dataActions.setScholar({'record': record});
		this.forceUpdate();
	}

	onEditIndex(id) {
		if(this.state.editIndex === id)
			return;
		if(this.state.editIndex && this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex' : id
		})
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	render() {
		const record = this.props.record;

		if(!record[this.state.field])
			return (<h6 className="flex-grow-1 font-weight-bold align-bottom mt-3 mb-1" style={{fontSize: "13px"}}>기타 아이디 관리는 저장후 가능합니다</h6>)

		return (
			<>
				<div className="d-flex justify-content-end mt-2 mb-1">
					<h6 className="flex-grow-1 font-weight-bold align-bottom mt-3 mb-1" style={{fontSize: "13px"}}>기타 아이디 관리</h6>
					<button type="button" className="btn btn-sm btn-outline-dark" onClick={this.onInsert}>추가</button>
				</div>
				<table className="widefat fixed striped editable rm-scholar-ids">
					<thead>
					<tr>
						<th scope="col" id="id_type" className="column-id-type"><span>유형</span></th>
						<th scope="col" id="id_value" className="column-id-value"><span>아이디</span></th>
						<th scope="col" id="action" className="column-action"><span>액션</span></th>
					</tr>
					</thead>
					<tbody id="the-list">
					{record[this.state.field].map((record, index) => {
						return (
							<IdsItem
								key={record[this.state.pkKey]}
								index={record[this.state.pkKey]}
								ref={"ref" + record[this.state.pkKey]}
								arrIndex={index}
								pkKey={this.state.pkKey}
								record={record}
								onUpdate={this.onUpdate}
								onRemove={this.onRemove}
								onEditIndex={this.onEditIndex}
								showMessage={this.showMessage}
								category={this.state.category}
								categoryName={this.state.categoryName}
							/>
						)
					})}
					{record[this.state.field].length <= 0 &&
					<tr className="list-row">
						<td className="column-id-type p-2" colSpan={3}>
							결과가 없습니다.
						</td>
					</tr>
					}
					</tbody>
				</table>
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.scholars.record ? state.scholars.record : {},
		meta: state.scholars.meta ? state.scholars.meta : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(Ids)
